export const queryKeys = {
  course: {
    availableCourses: (isAdmin) => ["course", "available", { isAdmin }],
    allAvailableCourses: () => ["course", "available"],
    content: (course, isAdmin) => ["course", "content", course, { isAdmin }],
    allContent: () => ["course", "content"],
    textbooks: (course) => ["course", "textbooks", course],
  },
  admin: {
    root: () => ["admin"],
    health: () => ["admin", "health"],
    stats: () => ["admin", "stats"],
    rateLimits: {
      config: () => ["admin", "rate-limits", "config"],
    },
    users: {
      all: () => ["admin", "users"],
      list: (params) => ["admin", "users", "list", params],
      detail: (userId) => ["admin", "users", "detail", userId],
    },
    support: {
      all: () => ["admin", "support"],
      list: (params) => ["admin", "support", "list", params],
      detail: (ticketId) => ["admin", "support", "detail", ticketId],
      summary: () => ["admin", "support", "summary"],
    },
    featureFlags: () => ["admin", "feature-flags"],
    auditLog: (params) => ["admin", "audit-log", params],
    collections: {
      all: () => ["admin", "collections"],
      list: (name, params) => ["admin", "collections", "list", name, params],
      detail: (name, docId) => ["admin", "collections", "detail", name, docId],
    },
    aiUsage: {
      summary: (params) => ["admin", "ai-usage", "summary", params],
      users: (params) => ["admin", "ai-usage", "users", params],
      events: (params) => ["admin", "ai-usage", "events", params],
      costControls: () => ["admin", "ai-usage", "cost-controls"],
      costStatus: () => ["admin", "ai-usage", "cost-status"],
    },
    guestUsage: {
      summary: (params) => ["admin", "guest-usage", "summary", params],
      live: (params) => ["admin", "guest-usage", "live", params],
    },
    creationLab: {
      all: () => ["admin", "creation-lab"],
      status: () => ["admin", "creation-lab", "status"],
      presets: (mode) => ["admin", "creation-lab", "presets", mode],
      preset: (presetId) => ["admin", "creation-lab", "preset", presetId],
      projects: (mode) => ["admin", "creation-lab", "projects", mode],
      project: (projectId) => ["admin", "creation-lab", "project", projectId],
      revision: (revisionId) => ["admin", "creation-lab", "revision", revisionId],
    },
    flervalg: {
      status: () => ["admin", "flervalg", "status"],
    },
  },
  problems: {
    all: () => ["problems"],
    list: (params) => ["problems", "list", params],
    byCourse: (course) => ["problems", "list", { course }],
    count: (params) => ["problems", "count", params],
    navList: (params) => ["problems", "nav-list", params],
    pensumCounts: (course, scope, level = "") => [
      "problems",
      "pensum-counts",
      { course, scope, level },
    ],
  },
};
